import React from 'react';
import PropTypes from 'prop-types';
import {translate} from 'react-i18next'
import Spinner from '@atlaskit/spinner';

class Payment extends React.Component {
    onClickPayment(event) {
        let {id, isLoading} = this.props;
        if (!isLoading) {
            this.props.onPayment({id});
        }
    }

    render() {
        let {t, canChangePay, isLoading} = this.props;
        return (
            <React.Fragment>
                <button
                    className={`ml-2 a-btn a-btn--payment
                    ${canChangePay ? '' : 'a-btn--disable-action'}
                    ${isLoading ? 'a-btn--disable-action':''}`}
                    onClick={this.onClickPayment.bind(this)}
                >
                    <span className={isLoading ? "pt-1" : "hidden"}>
                        <Spinner invertColor  size="small" isCompleting={false}/>&nbsp;&nbsp;
                    </span>
                    {t('order:detail.payment')}
                </button>
            </React.Fragment>
        );
    }
}

Payment.defaultProps = {
    canChangePay: false,
    isLoading: false,
    onPayment: () => {
    },
    id: 0,
};

Payment.propTypes = {
    canChangePay: PropTypes.bool,
    isLoading: PropTypes.bool,
    onPayment: PropTypes.func,
    id: PropTypes.number,
};

export default translate('translations')(Payment);
